import React from 'react';
import { Typography } from '@components/atoms/typography';
import type { LabeledFieldProps } from '@components/moleculs/labeled-field/types';
import { styled } from '@mui/material/styles';
import cn from 'classnames';

import { FieldLabel } from '../../atoms/field-label';

import { LabeledFieldContainer } from './styles';

const Molecule: React.FC<LabeledFieldProps> = ({
    label,
    rightLabel,
    isRequired,
    children,
    className,
    labelClassName,
    style,
    fullWidth,
    typographyProps,
}) => (
    <LabeledFieldContainer className={cn(className, { 'full-width': fullWidth })} style={style}>
        <FieldLabel className={labelClassName}>
            <Typography variant='text-bold' color='text-light' {...typographyProps}>
                {label} {isRequired ? <span className='span-required'> *</span> : ''}
            </Typography>
            {!!rightLabel && <span>{rightLabel}</span>}
        </FieldLabel>
        {children}
    </LabeledFieldContainer>
);

export const LabeledField = styled(Molecule)({});
